"use client";

import clsx from "clsx";

import FavoriteIcon from "@/assets/svg/16/Favorite";
import useWishlist from "@/lib/hooks/useWishlist";

import styles from "./add-to-favorite-button.module.css";

const ClientAddToWishlistButton = ({ productId }: { productId: string }) => {
  const { toggle, isIncluded } = useWishlist(productId);

  const included = isIncluded();
  return (
    <button
      type="button"
      className={clsx(
        "transparent",
        "small",
        styles.wishlistButton,
        included && styles.active
      )}
      onClick={() => {
        toggle();
      }}
    >
      <div className={styles.inner__button}>
        <FavoriteIcon filled={included} />
        <span className={styles.text}>
          {included ? "Din favoritt" : "Favoritt"}
        </span>
      </div>
    </button>
  );
};

export default ClientAddToWishlistButton;
